module.exports = __webpack_public_path__ + "static/media/hualian.8abf80aa.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/hualian.png
 ** module id = 443
 ** module chunks = 0
 **/